<div class="photo-gallery">
    @for (image of imageList; track $index) {
        <img src="{{image.url}}" alt="{{image.altText}}" [style]="'grid-row-end: span ' + image.gridRowEnd" (click)="openModal(image)">

        @if (selectedImage) {
            <pc-image-modal [imageUrl]="selectedImage.url" (close)="closeModal()"></pc-image-modal>
        }
    }
</div>